import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Helmet } from 'react-helmet'
import isPreRendering from 'utils/isPreRendering'
import { isMobile } from 'utils/deviceDetector'
import { getCustomerInfoLocalStorage } from 'utils/customerInfoLocalStorage'

import {
  EstateListContainer,
  EstateHeaderContainer,
  FilterContainer,
  AdvertisingContainer,
  LeadModalContainer,
} from 'containers'
// import { Button, FiltersModal, Image } from 'components'
import { Button, ListBanner } from 'components'
import { useRoot, useFilter, useAlert } from 'store'
import { usePageView } from 'hooks/useGAPageView'
import { InternalErrorPage } from 'pages'
// import ContentLoader from 'react-content-loader'
import { BaseLayout } from 'templates'
import { setUtms } from 'utils/Utms'

// import { banners, numberOfBanners, getRandomBannerIndex } from './banners'

import styles from './Search.module.scss'

const SearchPage = ({ location: { search }, slug, discount }) => {
  // const [image, setImage] = React.useState(getRandomBannerIndex)
  // const [bannerVisible, setBannerVisible] = React.useState(false)

  // const { source, sourceMobile, sourceXLarge, link } = banners[image]
  const params = { slug, discount, search }

  const {
    getError,
    setError,
    setLeadModal,
    $root: { cookies, leadModal },
  } = useRoot()

  const {
    $filter,
    getFilterUrl,
    setLocalitiesFromUrl,
    setFiltersModal,
  } = useFilter()

  const {
    localities,
    filtersModal: { openModal },
  } = $filter
  const { checkOpenModalParams, getOpenModal } = useAlert()
  const isModalOpen = getOpenModal()

  // useLayoutEffect(() => {
  //   if (!isPreRendering()) {
  //     setBannerVisible(true)
  //   }
  // }, [])

  useEffect(() => {
    const isFirstParam =
      getFilterUrl().split('/')[1] === 'busca'
        ? '?openAlertModal=true'
        : '&openAlertModal=true'
    const param = isModalOpen ? isFirstParam : ''
    window.history.replaceState('busca', 'Title', `${getFilterUrl()}${param}`)
    // eslint-disable-next-line
  }, [isModalOpen])

  useEffect(() => {
    setLocalitiesFromUrl(slug, localities)
    // eslint-disable-next-line
  }, [localities])

  useEffect(() => {
    checkOpenModalParams(search)

    window.scrollTo(0, 0)

    setUtms(search)

    return () => setError(null)
  }, []) //eslint-disable-line

  // React.useEffect(() => {
  // return setImage(getRandomBannerIndex)
  // }, [])

  usePageView()

  // const hasActiveFilter = hasFilterActive(getFilterUrl())

  const advertising = <AdvertisingContainer />

  // const Placeholder = () => (
  //   <ContentLoader height={150}>
  //     <rect x="0" y={0} rx="3" ry="3" width="100%" height={150} />
  //   </ContentLoader>
  // )

  const emailResale = getCustomerInfoLocalStorage().email || ''

  useEffect(() => {
    if (!emailResale) {
      setTimeout(
        () => setLeadModal({ openModal: true, wasOpened: false }),
        90000
      )
    }
  }, [emailResale, setLeadModal])

  if (getError()) return <InternalErrorPage errorCode={getError()} />
  return (
    <>
      <Helmet>
        <title>Imóveis Emgea | Busca</title>
        <meta property="og:title" content="Imóveis Emgea | Busca" />
        <meta
          property="og:description"
          content="Descubra o que são os imóveis com desconto do Banco do Brasil!"
        />
        <meta property="og:url" content="https://seuimovelbb.com.br/busca" />
      </Helmet>
      <BaseLayout backgroundColor="gray" enableSearch={isMobile}>
        <ListBanner filters={$filter} />

        {/* {process.env.REACT_APP_CAMPAIGN &&
          ((!hasActiveFilter && isMobile) || !isMobile) && (
            <>
              {bannerVisible ? (
                <div className={styles.imageClear}>
                  <Image
                    source={source}
                    sourceMobile={sourceMobile}
                    sourceLarge={sourceXLarge}
                    link={link}
                    alt="Banner"
                  />
                </div>
              ) : (
                <Placeholder />
              )}
            </>
          )} */}
        {!isPreRendering() && (
          <div
            className={classNames(styles.buttonContainer, {
              [styles.hide]: cookies,
            })}
          >
            <Button
              name="filterButton"
              onClick={() => setFiltersModal('openModal', !openModal)}
              iconPosition="left"
              icon="filter"
              darkColor
              className={styles.filterButton}
            >
              Refinar Busca
            </Button>
          </div>
        )}
        <main className={styles.mainSearch} id="list">
          <div className={styles.container}>
            <EstateHeaderContainer />
            <div className={styles.sectionSearch}>
              <div className={styles.filters}>
                <FilterContainer />
                {advertising}
              </div>
              <div className={styles.result}>
                <EstateListContainer urlParams={params} />
              </div>
            </div>
          </div>
        </main>
        {!isPreRendering() && (
          <LeadModalContainer
            closeModal={() =>
              setLeadModal({ openModal: false, wasOpened: true })
            }
            opened={leadModal.openModal && !leadModal.wasOpened}
          />
        )}
      </BaseLayout>
    </>
  )
}

SearchPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  slug: PropTypes.string,
  discount: PropTypes.string,
}

SearchPage.defaultProps = {
  location: {
    search: '',
  },
  slug: undefined,
  discount: undefined,
}

export default SearchPage
